const PopupIcon = props => (
  <svg
    width={54}
    height={54}
    viewBox="0 0 54 54"
    fill="black"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_49_268)">
      <path d="M42.75 42.75H11.25V11.25H27V6.75H11.25C8.7525 6.75 6.75 8.775 6.75 11.25V42.75C6.75 45.225 8.7525 47.25 11.25 47.25H42.75C45.225 47.25 47.25 45.225 47.25 42.75V27H42.75V42.75ZM31.5 6.75V11.25H39.5775L17.46 33.3675L20.6325 36.54L42.75 14.4225V22.5H47.25V6.75H31.5Z" />
    </g>
    <defs>
      <clipPath id="clip0_49_268">
        <rect width={54} height={54} fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default PopupIcon
